import PropTypes from 'prop-types';
import { APONTAMENTO } from '../../../services/apontamentoProducao';

export const colaboradorProps = PropTypes.shape({
  cpf: PropTypes.string.isRequired,
  nome: PropTypes.string.isRequired,
  idContratado: PropTypes.number.isRequired,
  hourlyRate: PropTypes.number.isRequired,
  monthlyEstimate: PropTypes.number.isRequired,
  accessionDate: PropTypes.instanceOf(Date).isRequired,
  horistaMensalista: PropTypes.oneOf([
    APONTAMENTO.horistaMensalista.mensalista,
    APONTAMENTO.horistaMensalista.horista,
    undefined,
  ]),
});

export const parametrizacaoProps = PropTypes.shape({
  nome: PropTypes.string.isRequired,
  vigencia: PropTypes.instanceOf(Date).isRequired,
  adiantamento_auto: PropTypes.bool.isRequired,
  adiantamento_auto_valor: PropTypes.number.isRequired,
  ajuda_custo_auto: PropTypes.bool.isRequired,
  ajuda_custo_valor: PropTypes.number.isRequired,
  atual_comp_ap: PropTypes.bool.isRequired,
  atual_comp_ap_qtd_dias: PropTypes.number.isRequired,
  apresentar_coop_afast: PropTypes.bool.isRequired,
  apresentar_coop_afast_competencias: PropTypes.number.isRequired,
  mensa_propor_remu_admissao: PropTypes.bool.isRequired,
  horis_propor_remu_admissao: PropTypes.bool.isRequired,
  realiza_mult_requi_mens: PropTypes.bool.isRequired,
  base_hora: PropTypes.number.isRequired,
  exibe_param_apontamento: PropTypes.bool.isRequired,
});

export const calculoProps = PropTypes.shape({
  id: PropTypes.number.isRequired,
  requisicao: PropTypes.number.isRequired,
  contratado: PropTypes.number.isRequired,
  dias_trabalhados: PropTypes.number.isRequired,
  base_hora: PropTypes.number.isRequired,
  valor_hora: PropTypes.number.isRequired,
  producao: PropTypes.number.isRequired,
  variavel: PropTypes.number.isRequired,
  ajuda_custo: PropTypes.number.isRequired,
  reembolso: PropTypes.number.isRequired,
  total_rendimentos: PropTypes.number.isRequired,
  descontos_diversos: PropTypes.number.isRequired,
  adiantamento: PropTypes.number.isRequired,
  total_debitos: PropTypes.number.isRequired,
  liquido: PropTypes.number.isRequired,
});

export const requisicaoProps = PropTypes.shape({
  id: PropTypes.number.isRequired,
  inquilino: PropTypes.string.isRequired,
  folha: PropTypes.shape().isRequired,
  competencia: PropTypes.instanceOf(Date).isRequired,
  dataPrevistaFatura: PropTypes.instanceOf(Date).isRequired,
  tipo: PropTypes.string.isRequired,
  status: PropTypes.number.isRequired,
  data: PropTypes.instanceOf(Date).isRequired,
  colaboradores: PropTypes.arrayOf(colaboradorProps),
  observacao: PropTypes.string.isRequired,
  dataPrevista: PropTypes.instanceOf(Date).isRequired,
  descricao: PropTypes.string.isRequired,
});

export const operacaoLogProps = PropTypes.shape({
  id: PropTypes.number,
  carteiraFolha: PropTypes.string,
  dataProcessamento: PropTypes.string,
  dataEntrada: PropTypes.string,
  dataPrevistaFatura: PropTypes.string,
  dataPrevistaPagamento: PropTypes.string,
  hora: PropTypes.string,
  nomeFolha: PropTypes.string,
  idFolha: PropTypes.number,
  nroRequisicao: PropTypes.number,
  observacao: PropTypes.string,
  observacaoAdmin: PropTypes.string,
  relacionamento: PropTypes.string,
  tipoOperacao: PropTypes.string,
  tipoRequisicao: PropTypes.string,
  usuario: PropTypes.string,
  valorLiquidoFolha: PropTypes.number,
  valorPortal: PropTypes.number,
});
